import api from '../../api'

export type TenantBudgetReportDataRow = {
  tenantId: number
  tenantName: string
  timestamp: string
  daysSinceApplied: number
}

export const getTenantBudgetReportData = async () => {
  const response = await api.get<TenantBudgetReportDataRow[]>('/web/tenant-report/budget')
  return response.data
}
